/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Col, Container, Form, FormGroup, Row } from "reactstrap";
import { Input } from "reactstrap";
import { Label } from "reactstrap";
import { catchError } from "../../utils/Utils";
import SpinnerModel from "../../commonfields/SpinnerModel";
import Service from "../../services";
import './scheduleA.scss';
import { BankUserContext } from "../../bankUserContext";
import mainLogo from '../../images/pricinfSheetLogo.png'
interface ViewScheduleProps {
  readonly: string;
  onBoarding : boolean;
}

const ViewSchedule: React.FC<any> = (props: ViewScheduleProps) => {
  const [formData2, setFormData2] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [isCannabis, setIsCannabis] = useState(false);
  const service = new Service();
  const { clientId, id } = useParams();   
  // const clientId  = "b297dbde-8301-42f6-b6fe-534751628780";
  const [prevObj, setPrevObj] = useState<any>({});
  const bankUserContext = useContext(BankUserContext);
  const location = useLocation();  
  const isReadOnly = !(location?.state?.editable || false);
  // const iconsURL = getIconsUrl(bankUserContext?.bankuserDetails?.userProfile?.profileName);
  useEffect(() => {
     setLoading(true);            
      service
        .getPaymentScheduleByClientId(clientId)
        .then((r: any) => {
          for (const k in r.data) {
            if (r.data[k] === 0) {
              r.data[k] = "";
            } else if (r.data[k] && typeof r.data[k]!=='boolean' && !isNaN(r.data[k])) {
              r.data[k] = Number(r.data[k])?.toFixed(2) || r.data[k];
            }
          }
          setFormData2(r.data);
        })
        .catch((error: AxiosError) => {
          catchError(error, true);      
        })
        .finally(() => {
            setLoading(false);
        })
        
      //  } else if(props.onBoarding && id){
      //   service
      //     .getPaymentScheduleForOnboarding(id)
      //     .then((r: any) => {
      //       for (const k in r.data) {
      //         if (r.data[k] === 0) {
      //           r.data[k] = "";
      //         } else if (r.data[k] && typeof r.data[k]!=='boolean' && !isNaN(r.data[k])) {
      //           r.data[k] = Number(r.data[k])?.toFixed(2) || r.data[k];
      //         }
      //       }
      //       setFormData2(r.data);
      //     })
      //     .catch((error: AxiosError) => {
      //       catchError(error, true);
      //       // eslint-disable-next-line @typescript-eslint/no-empty-function
      //     })
      //     .finally(() => {
      //         setLoading(false);
      //     })
      //   }
  }, [clientId]);

  useEffect(() => {

    setFormData2({
      ...formData2,
      // dbaName: bankUserContext?.scheduleClientData?.dba,
    });
  }, []);

  const saveData = (name: string, value: any) => {
    const payload = {
      [name]: value,
      clientUuid: clientId,
      paymentScheduleId: formData2.paymentScheduleUuid,
    };
     setLoading(true);
    // if(!props.onBoarding){
    //   service
    //   .savePaymentSchedule({ ...formData2, ...payload })
    //   .then((r: any) => {
    //     //toast.success("Successfully updated!");
    //   })
    //   .catch(() => {
    //     // toast.error("Something went wrong!");
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   })
    // } else if(props.onBoarding){
      service
      .savePaymentSchedule({ ...formData2, ...payload })
      .then((r: any) => {
        //toast.success("Successfully updated!");
      })
      .catch(() => {
        // toast.error("Something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
    }
  
// }
  const validateField = (event: any, type: string) => {
    // eslint-disable-next-line prefer-const
    let { value, name } = event.target;

    if (value.indexOf(".") == 0) value = 0 + value;
    if (type === "percent") {
      if (value > 100) {
        value = 100;
      }
    }
    const _formData = JSON.parse(JSON.stringify(formData2)) || {};
    _formData[name] = value;
    setFormData2(_formData);
  };
  const updateField = (event: any) => {
    let { value } = event.target;
    const { name } = event.target;
    if (value && typeof value!=='boolean' && !isNaN(value)) {
      value = Number(value)?.toFixed(2) || value;

      const _formData = JSON.parse(JSON.stringify(formData2)) || {};
      _formData[name] = value;
      setFormData2(_formData);
    }
    if (prevObj.prevVal == value && prevObj.name === name && !value) {
      return;
    }
    setPrevObj({
      prevVal: value,
      name,
    });

    saveData(name, value + "");
  };

  const updateCheckField = (e: any) => {
    const { checked, name } = e.target;
    const _formData = JSON.parse(JSON.stringify(formData2)) || {};
    _formData[name] = checked;
    setFormData2(_formData);
    setTimeout(() => saveData(name, checked), 2000);
  };
  const onKeyPressEvent = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9.]").test(keyValue)) event.preventDefault();
    return;
  };

  return (
    <div className={`viewSchedule ${isCannabis ? "cannabis" : "non-cannabis"}`}>
      {loading && (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      )}

      <Form onSubmit={(e: any) => e.preventDefault()} autoComplete="off">
        <Container>
          <Row className="schA">
            <Col xs="3">              
                {
                  // bankUserContext?.bankuserDetails?.userProfile?.profileName?.toLowerCase() === 'pnx' ? 
                  // <img src={payLogo} alt="mainLogo" className="mainLogo" /> : 
                  <img src={mainLogo} alt="mainLogo" className="mainLogo" /> 
                }            
              <h3>PRICING SHEET</h3>
            </Col>

            {/* <Col xs="3">
              <Input
                disabled={isReadOnly || formData2.dbaName}
                type="text"
                onBlur={(e: any) => updateField(e)}
                onChange={(e: any) => validateField(e, "")}
                value={formData2.dbaName}
                name="dbaName"
                className="dbaName"
              />
              <div className="dbaandsignature">DBA Name</div>
            </Col> */}
           

            <Col xs="3">
            
            </Col>

            <Col xs="3">
          
            </Col>
          </Row>
          <Row>
          
          </Row>
          <Row className="mainRow">
            <Col xs="3" className="processingrates">
              PROCESSING RATES:{" "}
            </Col>
            <Col xs="4" className="block">
              <div className="block-container">
                <span>Billing Options Requested:</span>
                <FormGroup check>
                  <Label check>
                    {formData2.billingOptionsRequestDaily ? (
                      <Input
                        disabled={isReadOnly}
                        checked
                        name="billingOptionsRequestDaily"
                        type="checkbox"
                        className="tick1"
                        onChange={updateCheckField}
                      />
                    ) : (
                      <Input
                        disabled={isReadOnly}
                        name="billingOptionsRequestDaily"
                        type="checkbox"
                        onChange={updateCheckField}
                      />
                    )}
                    Daily
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    {formData2.billingOptionsRequestMonthly ? (
                      <Input
                        disabled={isReadOnly}
                        checked
                        name="billingOptionsRequestMonthly"
                        type="checkbox"
                        className="tick1"
                        onChange={updateCheckField}
                      />
                    ) : (
                      <Input
                        disabled={isReadOnly}
                        name="billingOptionsRequestMonthly"
                        type="checkbox"
                        onChange={updateCheckField}
                      />
                    )}
                    Monthly
                  </Label>
                </FormGroup>
              </div>
            </Col>
            <Col xs="5" className="block">
              <div className="block-container section2">
                <FormGroup check>
                  <Label check>
                    {formData2.nextdayFundingRequest ? (
                      <Input
                        disabled={isReadOnly}
                        checked
                        name="nextdayFundingRequest"
                        type="checkbox"
                        className="tick1"
                        onChange={updateCheckField}
                      />
                    ) : (
                      <Input
                        disabled={isReadOnly}
                        name="nextdayFundingRequest"
                        type="checkbox"
                        onChange={updateCheckField}
                      />
                    )}
                    <span className="fundingRequest">Next Day Funding Requested </span>
                  </Label>
                </FormGroup>
                <FormGroup check className="monthly-fee-form-check">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.monthlyFee}
                      name="monthlyFee"
                      className="secondaryTextBox monthlyFee"
                    />
                    </div>
                 

                  <Label check>Monthly Fee</Label>
                </FormGroup>
              </div>
            
            </Col>
          </Row>
          <Row className="secondaryRow tierdRow">
            <Col xs="3" className="bar2">
              <FormGroup check>
                <Label check>
                  {formData2.tired ? (
                    <Input
                      disabled={isReadOnly}
                      className="tick1"
                      checked
                      name="tired"
                      type="checkbox"
                      onChange={updateCheckField}
                    />
                  ) : (
                    <Input
                      disabled={isReadOnly}
                      name="tired"
                      type="checkbox"
                      onChange={updateCheckField}
                    />
                  )}
                  <span className="sidecheck">Tiered</span>
                </Label>
              </FormGroup>
            </Col>

            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="cell-bar2">Qualified</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">+ Mid-Qualified</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">+ Non-Qualified</div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="3">
                  <div className="cell-bar2 transactionfee">
                    Transaction Fee
                  </div>
                </Col>
                <Col xs="3">
                  <div className="cell-bar2 transactionfee">
                    Authorization Fee
                  </div>
                </Col>
                {/* <Col xs="3"><div className="cell-bar2">Non-Qualified</div></Col>
                                <Col xs="3"><div className="cell-bar2">Authorization</div></Col> */}
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              VISA, MASTERCARD Debit
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaDebitPlusQualified}
                      name="tieredVisaDebitPlusQualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  {" "}
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaDebitPlusMidqualified}
                      name="tieredVisaDebitPlusMidqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  {" "}
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaDebitPlusNonqualified}
                      name="tieredVisaDebitPlusNonqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredTransactionDebit}
                      name="tieredTransactionDebit"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAuthorizationDebit}
                      name="tieredAuthorizationDebit"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              VISA, MASTERCARD Credit
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaCreditPlusQualified}
                      name="tieredVisaCreditPlusQualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaCreditPlusMidqualified}
                      name="tieredVisaCreditPlusMidqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredVisaCreditPlusNonqualified}
                      name="tieredVisaCreditPlusNonqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredTransactionCredit}
                      name="tieredTransactionCredit"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAuthorizationCredit}
                      name="tieredAuthorizationCredit"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              DISCOVER
            </Col>

            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAmexPlusQualified}
                      name="tieredAmexPlusQualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAmexPlusMidqualified}
                      name="tieredAmexPlusMidqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAmexPlusNonqualified}
                      name="tieredAmexPlusNonqualified"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredTransactionDiscover}
                      name="tieredTransactionDiscover"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.tieredAuthorizationDiscover}
                      name="tieredAuthorizationDiscover"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow  tierdRow">
            <Col xs="3" className="bar2">
              <FormGroup check>
                <Label check>
                  {formData2.costPlus ? (
                    <Input
                      disabled={isReadOnly}
                      checked
                      name="costPlus"
                      type="checkbox"
                      className="tick1"
                      onChange={updateCheckField}
                    />
                  ) : (
                    <Input
                      disabled={isReadOnly}
                      name="costPlus"
                      type="checkbox"
                      onChange={updateCheckField}
                    />
                  )}
                  <span className="sidecheck"> Cost Plus</span>
                </Label>
              </FormGroup>
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="cell-bar2">Discount</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Transaction</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Authorization</div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="6">
                  <div className="bar2">
                    <span className="achrates">Additional Services</span>
                  </div>{" "}
                </Col>
                <Col xs="3">
                  <div className="cell-bar2">Discount</div>
                </Col>
                <Col xs="3">
                  <div className="cell-bar2">Transaction</div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              VISA, MASTERCARD
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusVisaDiscount}
                      name="costPlusVisaDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusVisaTransaction}
                      name="costPlusVisaTransaction"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusVisaAuthorization}
                      name="costPlusVisaAuthorization"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="6">
                  <div className="bar2"><span className="additionalservices">PIN Based Debit</span></div>
                </Col>
                <Col xs="3">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.pinBasedDebitDiscount}
                      name="pinBasedDebitDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.pinBasedDebitAmount}
                      name="pinBasedDebitAmount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              DISCOVER
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusAmexDiscount}
                      name="costPlusAmexDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>

                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusAmexTransaction}
                      name="costPlusAmexTransaction"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>

                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.costPlusAmexAuthorization}
                      name="costPlusAmexAuthorization"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="9">
                  <div className="bar2"><span className="additionalservices">Debit Network Fee</span></div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.debitNetworkFee}
                      name="debitNetworkFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow tierdRow">
            <Col xs="3" className="bar2">
              <FormGroup check>
                <Label check>
                  {formData2.flatRate ? (
                    <Input
                      disabled={isReadOnly}
                      checked
                      name="flatRate"
                      type="checkbox"
                      className="tick1"
                      onChange={updateCheckField}
                    />
                  ) : (
                    <Input
                      disabled={isReadOnly}
                      name="flatRate"
                      type="checkbox"
                      onChange={updateCheckField}
                    />
                  )}
                  <span className="sidecheck"> Flat Rate</span>
                </Label>
              </FormGroup>
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="cell-bar2">Discount</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Transaction</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Authorization</div>
                </Col>
              </Row>
            </Col>
            <Col xs="5"></Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              VISA, MASTERCARD
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateVisaDiscount}
                      name="flatRateVisaDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateVisaTransaction}
                      name="flatRateVisaTransaction"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateVisaAuthorization}
                      name="flatRateVisaAuthorization"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="6">
                  <div className="bar2"><span className="additionalservices">EBT Per Item Fee</span></div>
                </Col>
                <Col xs="3">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.ebtperitemDiscount}
                      name="ebtperitemDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>

                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.ebtPerItemFee}
                      name="ebtPerItemFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2">
              DISCOVER
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateAmexDiscount}
                      name="flatRateAmexDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateAmexTransaction}
                      name="flatRateAmexTransaction"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.flatRateAmexAuthorization}
                      name="flatRateAmexAuthorization"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5">
              <Row>
                <Col xs="12">
                  <div className="ebt amex-account-block">
                    <span className="additionalservices eebt">EBT#:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.ebt}
                        name="ebt"
                        className="secondaryTextBox ebttextbox"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="3" className="bar2 amexaccouncheckbox">
              <FormGroup check>
                <Label check>
                  {formData2.amexAccountCheckbox ? (
                    <Input
                      disabled={isReadOnly}
                      checked
                      name="amexAccountCheckbox"
                      type="checkbox"
                      className="tick1"
                      onChange={updateCheckField}
                    />
                  ) : (
                    <Input
                      disabled={isReadOnly}
                      name="amexAccountCheckbox"
                      type="checkbox"
                      onChange={updateCheckField}
                    />
                  )}
                  <span className="sidecheck">AMEX Account</span>
                </Label>
              </FormGroup>
            </Col>
            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="cell-bar2">Discount</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Transaction</div>
                </Col>
                <Col xs="4">
                  <div className="cell-bar2">Authorization</div>
                </Col>
              </Row>
            </Col>
            <Col xs="5"></Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="3" className="bar2 amexaccouncheckbox">
            <span className="additionalservices eebt"> AMEX Discount</span>
            </Col>

            <Col xs="4">
              <Row>
                <Col xs="4">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.amexDiscount}
                      name="amexDiscount"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.amexTransaction}
                      name="amexTransaction"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
                <Col xs="4">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.amexAuthorization}
                      name="amexAuthorization"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs="5"></Col>
          </Row>
          <Row>
            <Col xs="7">
              <Row>
                <Col xs="10">
                  <div className="block-container amex-account-block existingamexaccount">
                    <span className="additionalservices eebt">Existing AMEX Account No:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.existingAmexAccountNo}
                        name="existingAmexAccountNo"
                        className="secondaryTextBox existing"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6" className="pl0">
              <h5 className="serviceChargeSection">
              Rates & Other Fees
              </h5>
            </Col>

            <Col xs="6" className="pl0">
              <h5 className="serviceChargeSection">
                Optional Services(Available on request)
              </h5>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  3-D Secure (per Transaction) Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.secureFee}
                      name="secureFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Wireless Terminal Activiation Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.wirelessTerminalActivationFee}
                      name="wirelessTerminalActivationFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Cash Discount / Surcharge Rate
                </Col>
                <Col xs="3">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.surchargeRate}
                      name="surchargeRate"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Wireless Monthly Service per Device Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.wirelessTerminalServiceFee}
                      name="wirelessTerminalServiceFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Cash Discount / Surcharge Monthly Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.surchargeMonthlyFee}
                      name="surchargeMonthlyFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Transaction Recycling ( per Transaction )
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.transactionRecycling}
                      name="transactionRecycling"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Cash Discount Flat Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.cashDiscountFlatFee}
                      name="cashDiscountFlatFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Account Updater ( per Transaction )
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.accountUpdater}
                      name="accountUpdater"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Application Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <div className="dollar-input">
                      <Input
                        disabled={isReadOnly}
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "currency")}
                        min="0"
                        onKeyPress={onKeyPressEvent}
                        type="number"
                        value={formData2.applicationFee}
                        name="applicationFee"
                        className="secondaryTextBox"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Gateway One time Set-up Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.gatewayOnetimeSetupFee}
                      name="gatewayOnetimeSetupFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Account Set Up Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.accountSetupFee}
                      name="accountSetupFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Gateway Fee Monthly
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.gatewayMonthlyFee}
                      name="gatewayMonthlyFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Monthly Minimum Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.monthlyMinimumFee}
                      name="monthlyMinimumFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Gateway per Transaction Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.gatewayTransactionFee}
                      name="gatewayTransactionFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Monthly Account on File Fee{" "}
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.monthlyAccountFileFee}
                      name="monthlyAccountFileFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  POS Hardware Purchase
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.posHardwarePurchase}
                      name="posHardwarePurchase"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  PCI Non-Compliance Fee ( per Occurence )
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.pciNonComplianceFee}
                      name="pciNonComplianceFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="12" className="block">
                  <div className="optional amex-account-block">
                    <span>Terminal/POS Type:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.posType}
                        name="posType"
                        className="secondaryTextBox note"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  <div className="block-container2">
                    PCI Compliance (
                    <span className="sidecheck"><span className="downcheckbox">Monthly&nbsp;</span></span>{" "}
                    <FormGroup check>
                      <Label check>
                        {formData2.pciComplianceMonthly ? (
                          <Input
                            disabled={isReadOnly}
                            checked
                            className="tick1"
                            name="pciComplianceMonthly"
                            type="checkbox"
                            onChange={updateCheckField}
                          />
                        ) : (
                          <Input
                            disabled={isReadOnly}
                            name="pciComplianceMonthly"
                            type="checkbox"
                            onChange={updateCheckField}
                          />
                        )}
                      </Label>
                    </FormGroup>
                    <span className="sidecheck"><span className="downcheckbox">Yearly&nbsp;</span></span>
                    <FormGroup check>
                      <Label check>
                        {formData2.pciComplianceYearly ? (
                          <Input
                            disabled={isReadOnly}
                            checked
                            className="tick1"
                            name="pciComplianceYearly"
                            type="checkbox"
                            onChange={updateCheckField}
                          />
                        ) : (
                          <Input
                            disabled={isReadOnly}
                            name="pciComplianceYearly"
                            type="checkbox"
                            onChange={updateCheckField}
                          />
                        )}
                        <span className="downcheckbox">Fee</span>)
                      </Label>
                    </FormGroup>
                  </div>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.pciComplianceFee}
                      name="pciComplianceFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="12" className="block">
                  <div className="optional amex-account-block">
                    <span>Note:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.posNotes}
                        name="posNotes"
                        className="secondaryTextBox note fulllength"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Batch/Settlement Fee ( per Batch )
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.batchSettlementFee}
                      name="batchSettlementFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  POS Software Purchase
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.posSoftwarePurchase}
                      name="posSoftwarePurchase"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Monthly Help Desk Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.monthlyHelpdeskFee}
                      name="monthlyHelpdeskFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="12" className="block">
                  <div className="optional amex-account-block">
                    <span>SoftwareName:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.softwareName}
                        name="softwareName"
                        className="secondaryTextBox note"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Reject Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achRejectFee}
                      name="achRejectFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="12" className="block">
                  <div className="optional amex-account-block">
                    <span>Note:</span>
                    <FormGroup check>
                      <Input
                        disabled={isReadOnly}
                        type="text"
                        onBlur={(e: any) => updateField(e)}
                        onChange={(e: any) => validateField(e, "")}
                        value={formData2.softwareNotes}
                        name="softwareNotes"
                        className="secondaryTextBox note fulllength"
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Chargeback Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.chargebackFee}
                      name="chargebackFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                Virtual Terminal Monthly Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.installationTrainingFee}
                      name="installationTrainingFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Retrieval Request Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.retrievalRequestFee}
                      name="retrievalRequestFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="12" className="bar2 ach">
                  <div>
                    <span className="achrates">ACH Rates & Fees </span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  <span className="achrates">AVS/CVV Fee</span>
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.avsFee}
                      name="avsFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Discount Rate
                </Col>
                <Col xs="3">
                  <div className="percent-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "percent")}
                      min="0"
                      max ="100"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achDiscountRate}
                      name="achDiscountRate"
                      className="secondaryTextBox"
                    />                  
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Reports (monthly)
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.reports}
                      name="reports"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Per Item Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achPeritemFee}
                      name="achPeritemFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Account File Change Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.accountFileChangeFee}
                      name="accountFileChangeFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Monthly Maintenance Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achMonthlyMaintenanceFee}
                      name="achMonthlyMaintenanceFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Early Termination Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.earlyTerminationFee}
                      name="earlyTerminationFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Monthly Minimum Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achMonthlyMinimumFee}
                      name="achMonthlyMinimumFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  Other Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.otherFee}
                      name="otherFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs="6">
              <Row>
                <Col xs="9" className="bar2">
                  ACH Change Fee
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achChangeFee}
                      name="achChangeFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="secondaryRow">
            <Col xs="6" className="pLClear">
              <span className="transworx2"> Pricing Sheet </span>
              is based on Merchant’s representation of transaction size and
              volume and method of processing as represented on the Merchant
              Application and Merchant acknowledges that, to the extent
              Merchant’s actual transaction size and volume and method of
              processing differ from such representation, Bank or
              {/* <span className="transworx2">
                { bankUserContext?.bankuserDetails?.userProfile?.profileName?.toLowerCase() === 'pnx' 
                  ? " PayNetWorx " : " Ember " }
              </span> */}
              &nbsp;may, at their option, from time to time, modify
              <span className="transworx2"> Pricing Sheet </span>.
            </Col>

            <Col xs="6">
              <Row className="secondaryRow">
                <Col xs="9" className="bar2">
                  ACH Fee Per Returned Item (NSF, etc.)
                </Col>
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.achFeePerReturnedItem}
                      name="achFeePerReturnedItem"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="secondaryRow">
                <Col xs="9" className="block bar2">
                  <div className="optional amex-account-block">
                    <span><Col xs="3">Misc.Fee</Col></span>
                    <FormGroup check>
                      <div className="optional amex-account-block fulllength2">
                       <Col xs= "9"> <Input 
                          disabled={isReadOnly}
                          onBlur={(e: any) => updateField(e)}
                          onChange={(e: any) => validateField(e, "")}
                          // onKeyPress={onKeyPressEvent}
                          type="text"
                          value={formData2.miscNotes}
                          name="miscNotes"
                          className="secondaryTextBox"
                        /></Col>
                      </div>
                    </FormGroup>
                  </div>
                </Col>

                {/* <Col xs="9" className="bar2">Misc.Fee</Col> */}
                <Col xs="3">
                  <div className="dollar-input">
                    <Input
                      disabled={isReadOnly}
                      onBlur={(e: any) => updateField(e)}
                      onChange={(e: any) => validateField(e, "currency")}
                      min="0"
                      onKeyPress={onKeyPressEvent}
                      type="number"
                      value={formData2.miscFee}
                      name="miscFee"
                      className="secondaryTextBox"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col xs="3">
            {!isReadOnly ? (
              <button className="close" onClick={() => window.close()}>
                Close
              </button>
            ) : (
              ""
            )}
          </Col>
        </Container>
      </Form>
    </div>
  );
};

export default ViewSchedule;
